import { Typography } from 'seagull';
import ExternalLinkButton from "../../../../components/ExternalLinkButton";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const LevvySteps = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(Typography, {
    children: "2. In Levvy, open the Integrations page, find Anchor, and click Connect."
  }), /*#__PURE__*/_jsx(Typography, {
    children: "3. When prompted, paste your API key into the Anchor API Key field"
  }), /*#__PURE__*/_jsx(ExternalLinkButton, {
    href: "http://help.sayanchor.com/en/articles/13003522-levvy",
    openInNewTab: true,
    style: {
      marginTop: 16
    },
    "data-testid": "levvy-help-center-link",
    children: "Read more in the Help Center"
  })]
});